import { Component, Input, OnInit, SimpleChanges, OnChanges } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Aeroplanta as AeroplantaDespacho } from '@shared/models/despacho/Aeroplanta';
import { Aeroplanta } from '@shared/models/cierreTurno/Aeroplanta';
import { TipoAeroplanta } from '@shared/enums/TipoAeroplanta';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProductoService } from '@abm/producto/producto.service';
import { Producto } from '@shared/models/abm/Producto';
import { DetalleProducto } from '@shared/models/cierreTurno/DetalleProducto';
import { StockService } from '@stock/stock.service';
import { Terminal } from '@shared/models/stock/Terminal';
import { Contacto } from '@shared/models/cierreTurno/Contacto';
import { CierreTurnoService } from '@cierreTurno/cierre-turno.service';
import { MessageService } from '@shell/message.service';
import { UsuarioService } from '@account/usuario.service';
import { AuthService } from '@authentication/auth.service';
import { TipoUsuario } from '@shared/enums/tipoUsuario';
import { Responsable } from '@shared/models/stock/Responsable';
import { TipoResponsable } from '@shared/enums/TipoResponsable';
import { GrupoContacto } from '@shared/enums/GrupoContacto';

@Component({
  selector: 'app-aeroplantas-detalle',
  templateUrl: './aeroplantas-detalle.component.html',
  styleUrls: ['./aeroplantas-detalle.component.scss']
})
export class AeroplantasDetalleComponent implements OnInit, OnChanges {

  aeroplantaForm:FormGroup;
  aeroplantas;
  aeroplanta: Aeroplanta;
  cargandoDetalle: boolean = false;
  cargandoTerminales: boolean = false;
  cargandoProductos: boolean = false;
  cargandoContactos: boolean = false;
  cargandoResponsables: boolean = false;
  guardando: boolean = false;
  productos: Producto[];
  TipoAeroplanta=TipoAeroplanta;
  TipoUsuario = TipoUsuario;
  @Input() aeroplantaSeleccionada: AeroplantaDespacho;
  terminales: Terminal[] = [];
  detalleProductos: DetalleProducto[];
  detalleProductosSeleccionados: Producto[] = [];
  contactos: Contacto[] = [];
  usuariosResponsableProducto: Responsable[] = [];

  TipoResponsable = TipoResponsable;

  listOperadoresDisponibles: Contacto[] = [];
  listOperadoresSeleccionados: Contacto[] = [];
  listRefTecnicosDisponibles: Contacto[] = [];
  listRefTecnicosSeleccionados: Contacto[] = [];
  listRefGestionDisponibles: Contacto[] = [];
  listRefGestionSeleccionados: Contacto[] = [];
  listRefComercialDisponibles: Contacto[] = [];
  listRefComercialSeleccionados: Contacto[] = [];
  listRuteadoresDisponibles: Contacto[] = [];
  listRuteadoresSeleccionados: Contacto[] = [];

  constructor(
    private fb: FormBuilder,
    private cierreTurnoService: CierreTurnoService,
    private productoService: ProductoService,
    private stockService: StockService,
    private messageService: MessageService,
    private spinner:NgxSpinnerService,
    private usuarioService: UsuarioService,
    public authService: AuthService) { }

  ngOnInit(): void {    
    this.crearFormulario();
    this.inicializarDatos();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes.aeroplantaSeleccionada.firstChange) {
      this.cargarFormulario();
      this.usuariosResponsableProducto = [];
    }
  }

  mostrarSpinner() {
    this.spinner.show('spinnerDetalle');
    this.cargandoDetalle = true;
  }
  
  ocultarSpinner() {    
    this.spinner.hide('spinnerDetalle');
    this.cargandoDetalle = false;
  }
  
  crearFormulario() {
    this.aeroplantaForm = this.fb.group({
      tipoAeroplantaFormControl: ['', Validators.required],
      productoFormControl: [''],
      detalleProductosFormControlArray: this.fb.array([]),
      firmaOperadorFormControl: [''],
      referenteTecnicoFormControl: [''],
      referenteGestionFormControl: [''],
      referenteComercialFormControl: [''],
      ruteadorFormControl: [''],
      horarioOperacionFormControl: [''],
      responsableFormControl: [''],
      suplenteFormControl: [''],
      obtieneTelemedicionesFormControl: ['']
    });
  }
  
  inicializarDatos = async () => {
    this.mostrarSpinner();
    this.terminales = await this.stockService.getTerminalesPromise();
    this.terminales.sort((a, b) => a.nombre > b.nombre ? 1 : -1);
    this.contactos = await this.cierreTurnoService.getContactos();
    this.contactos.sort((a, b) => a.nombre > b.nombre ? 1 : -1);
    this.cargarAeroplantas();
    this.getUsuariosResponsableProducto();
    this.cargarFormulario();
    this.listOperadoresDisponibles = [];
    this.listRefTecnicosDisponibles = [];
    this.listRefGestionDisponibles = [];
    this.listRefComercialDisponibles = [];
    this.listRuteadoresDisponibles = [];
  }

  getUsuariosResponsableProducto = async () => {
    this.cargandoResponsables = true
    const usuarios = await this.usuarioService.obtenerUsuariosConRoles([24, 11], this.aeroplantaSeleccionada.codigoAeroplanta);
    this.usuariosResponsableProducto = usuarios.map(usuario => {
      return {
        NombreCompleto: usuario.nombresCompletos,
        DNI: usuario.dni,
        UserName: usuario.userName
      }
    })
    this.aeroplanta.responsable ? this.responsableFormControl.setValue(this.usuariosResponsableProducto.find(r => r.DNI == this.aeroplanta.responsable.dni)) : this.responsableFormControl.setValue(this.usuariosResponsableProducto[0]);
    this.aeroplanta.sustituto ? this.suplenteFormControl.setValue(this.usuariosResponsableProducto.find(s => s.DNI == this.aeroplanta.sustituto.dni)) : this.suplenteFormControl.setValue(this.usuariosResponsableProducto[0]);
    this.cargandoResponsables = false;
  }

  cargarAeroplantas() {
    this.stockService.getAeroplantas(null).subscribe(aeroplantas => {
      this.aeroplantas = aeroplantas;
      const terminalesConCodigo = this.terminales.map(terminal => {
        const aeroplanta = this.aeroplantas.find(aeroplanta => aeroplanta.numeroAeroplanta == terminal.codigoTerminal);
        if (aeroplanta) terminal.codigoLetras = aeroplanta.codigoAeroplanta;
        else terminal.codigoLetras = terminal.codigoTerminal;
        return terminal;
      })
      this.terminales = terminalesConCodigo;
    });
  }

  cargarFormulario = async () => {
    try {      
      this.mostrarSpinner();
      const resp = await this.productoService.obtenerProductosPromise(); // reset array productos...
      this.getUsuariosResponsableProducto();
      this.productos = resp.filter(p=>p.rubro.aerocombustible || p.rubro.combustible).filter(p=>p.activo);
      this.productos.sort((a,b) => a.nombreProducto > b.nombreProducto ? 1 : -1);
      this.aeroplanta = await this.cierreTurnoService.getAeroplantas(this.aeroplantaSeleccionada.codigoAeroplanta);
      if (this.aeroplanta != null) {
        this.tipoAeroplantaFormControl.setValue(this.aeroplanta.tipoAeroplanta);
        
        const contactosOperadores = this.contactos.filter(c => c.gruposAeroplanta?.some(g => g.codigoAeroplanta === this.aeroplanta.codigo && g.gruposContacto.includes(GrupoContacto.firmaOperador) && !this.aeroplanta.firmasOperadoras.some(f => f.id === c.id)));
        this.listOperadoresDisponibles = contactosOperadores;
        this.listOperadoresSeleccionados = this.aeroplanta.firmasOperadoras;

        const contactosRefTecnicos = this.contactos.filter(c => c.gruposAeroplanta?.some(g => g.codigoAeroplanta === this.aeroplanta.codigo && g.gruposContacto.includes(GrupoContacto.referenteTecnico) && !this.aeroplanta.referentesTecnicos.some(f => f.id == c.id)));
        this.listRefTecnicosDisponibles = contactosRefTecnicos;
        this.listRefTecnicosSeleccionados = this.aeroplanta.referentesTecnicos;

        const contactosRefGestion = this.contactos.filter(c => c.gruposAeroplanta?.some(g => g.codigoAeroplanta === this.aeroplanta.codigo && g.gruposContacto.includes(GrupoContacto.referenteGestion) && !this.aeroplanta.referentesGestion.some(f => f.id === c.id)));
        this.listRefGestionDisponibles = contactosRefGestion;
        this.listRefGestionSeleccionados = this.aeroplanta.referentesGestion;

        const contactosRefComerciales = this.contactos.filter(c => c.gruposAeroplanta?.some(g => g.codigoAeroplanta === this.aeroplanta.codigo && g.gruposContacto.includes(GrupoContacto.referenteComercial) && !this.aeroplanta.referentesComerciales.some(f => f.id === c.id)));
        this.listRefComercialDisponibles = contactosRefComerciales;
        this.listRefComercialSeleccionados = this.aeroplanta.referentesComerciales;

        const contactosRuteadores = this.contactos.filter(c => c.gruposAeroplanta?.some(g => g.codigoAeroplanta === this.aeroplanta.codigo && g.gruposContacto.includes(GrupoContacto.ruteador) && !this.aeroplanta.ruteadores.some(f => f.id === c.id)));
        this.listRuteadoresDisponibles = contactosRuteadores;
        this.listRuteadoresSeleccionados = this.aeroplanta.ruteadores;
        
        this.horarioOperacionFormControl.setValue(this.aeroplanta.horarioOperacion);
        this.obtieneTelemedicionesFormControl.setValue(this.aeroplanta.obtieneTelemediciones);
        this.detalleProductosSeleccionados = [];
        this.detalleProductosFormControlArray.clear();
        for (const item of this.aeroplanta.productos) {
          const prod = this.productos.find(p=>p.codigoProducto == item.codigoProducto);
          this.detalleProductosSeleccionados.push(prod);
          this.detalleProductosFormControlArray.push(this.cargarDetalleProducto(item));
          const p = this.productos.indexOf(prod);
          this.productos.splice(p, 1);
    
          if (this.productos.length > 0) {
            this.productoFormControl.setValue(this.productos[0]);
          } else {
            this.productoFormControl.setValue(null);
          }          
        }
        this.ocultarSpinner();
      }
    } catch (error) {
      this.messageService.showErrorMessage('Hubo un error al obtener los datos de la aeroplanta.');
      this.aeroplanta = null;
      this.ocultarSpinner();
    }
  }

  agregarProductoSeleccionada() {
    if (this.productoFormControl.value) {
      this.detalleProductosSeleccionados.push(this.productoFormControl.value);
      this.detalleProductosFormControlArray.push(this.nuevoDetalleProducto());
      const p = this.productos.indexOf(this.productoFormControl.value);
      this.productos.splice(p, 1);

      if (this.productos.length > 0) {
        this.productoFormControl.setValue(this.productos[0]);
      } else {
        this.productoFormControl.setValue(null);
      }
    }
  }

  nuevoDetalleProducto(): FormGroup {
    return this.fb.group({
      codigoTerminal: ['', Validators.required],
      codigoProducto: [this.productoFormControl.value.codigoProducto, Validators.required],
      distanciaEnKM: ['', Validators.required],
      toleranciaMensualOperativa: ['', Validators.required],
      diasPromedio: ['', Validators.required],
      diasDemora: ['', Validators.required],
      stockSanitario: ['', Validators.required]
    });
  }

  depurarCodigoTerminal(str: string) {
    const posInicial = str.indexOf('(');
    const posFinal = str.indexOf(')');
    if(posInicial && posFinal == -1) {
      return str
    } else {
      return str.substring(posInicial+1, posFinal)
    }
  }

  cargarDetalleProducto(x: DetalleProducto): FormGroup {
    return this.fb.group({
      codigoTerminal: [this.depurarCodigoTerminal(x.codigoTerminal), Validators.required],
      codigoProducto: [x.codigoProducto, Validators.required],
      distanciaEnKM: [x.distanciaEnKM, Validators.required],
      toleranciaMensualOperativa: [x.toleranciaMensualOperativa, [Validators.required, Validators.min(0), Validators.max(99.99)]],
      diasPromedio: [x.diasPromedio, Validators.required],
      diasDemora: [x.diasDemora, Validators.required],
      stockSanitario: [x.stockSanitario, Validators.required]
    });
  }

  eliminarDetalle(i:number) {
    const codigo = this.detalleProductosFormControlArray.value[i].codigoProducto;
    const dp = this.detalleProductosSeleccionados.filter(p=>p.codigoProducto == codigo);
    this.productos.push(dp[0]);
    this.detalleProductosFormControlArray.removeAt(i);
    const p = this.detalleProductosSeleccionados.indexOf(dp[0]);
    this.detalleProductosSeleccionados.splice(p, 1);
    if (this.productos.length > 0) {
      this.productoFormControl.setValue(this.productos[0]);
    }
  }

  obtenerNombreTerminal(cod) {
    return this.terminales.find(t => t.codigoTerminal===cod).nombre;
  }

  procesarDetalleProductos() {
    const listaDetalleProductos = new Array<DetalleProducto>();

    if (this.aeroplantaForm != null) {
      for (let i = 0; i < this.detalleProductosFormControlArray.length; i++) {
        const terminal = '('+this.detalleProductosFormControlArray.value[i].codigoTerminal+') ' + this.obtenerNombreTerminal(this.detalleProductosFormControlArray.value[i].codigoTerminal);
        const producto = this.detalleProductosFormControlArray.value[i].codigoProducto;        
        const distancia = this.detalleProductosFormControlArray.value[i].distanciaEnKM;
        const tolerancia = this.detalleProductosFormControlArray.value[i].toleranciaMensualOperativa;
        const dias = this.detalleProductosFormControlArray.value[i].diasPromedio;
        const demora = this.detalleProductosFormControlArray.value[i].diasDemora;
        const stock = this.detalleProductosFormControlArray.value[i].stockSanitario;

        const detalle = new DetalleProducto();
        detalle.codigoTerminal = terminal;
        detalle.codigoProducto = producto;
        detalle.distanciaEnKM = distancia;
        detalle.toleranciaMensualOperativa = tolerancia;
        detalle.diasPromedio = dias;
        detalle.diasDemora = demora;
        detalle.stockSanitario = stock;
        
        listaDetalleProductos.push(detalle);
      }
    }

    return listaDetalleProductos;
  }

  compareContactos(n1: any, n2: any): boolean {  
    return n1 && n2 ? n1.id == n2.id : n1 == n2;
  }

  compareTerminal(n1: any, n2: any): boolean {  
    return n1 && n2 ? n1.codigoTerminal == n2 : n1 == n2;
  }

  accionarForm(){
    Object.keys(this.aeroplantaForm.controls).forEach(key => {
      this.aeroplantaForm.get(key).markAsDirty();
    });
  }
  
  onChangeDistancia(index:number) {
    const distancia = Number(this.detalleProductosFormControlArray.value[index].distanciaEnKM);
    this.detalleProductosFormControlArray.controls[index].get('diasDemora').setValue((distancia>0) ? Math.ceil(distancia/600)+1 : 0);
    this.detalleProductosFormControlArray.controls[index].get('distanciaEnKM').setValue(distancia);
  }

  /** boton guardar cambios */

  onClick = async () => {
    this.accionarForm();

    if(this.aeroplantaForm.valid) {
      this.guardando = true;

      const aeroplanta: Aeroplanta = {
        id: this.aeroplantaSeleccionada.id,
        nombre: this.aeroplantaSeleccionada.nombre,
        codigo: this.aeroplantaSeleccionada.codigoAeroplanta,
        tipoAeroplanta: Number(this.tipoAeroplantaFormControl.value),
        productos: this.procesarDetalleProductos(),
        /*firmaOperadora: this.firmaOperadorFormControl.value,
        referenteComercial: this.referenteComercialFormControl.value,
        referenteGestion: this.referenteGestionFormControl.value,
        referenteTecnico: this.referenteTecnicoFormControl.value,
        ruteador: this.ruteadorFormControl.value,*/
        
        firmasOperadoras: this.listOperadoresSeleccionados,
        referentesComerciales: this.listRefComercialSeleccionados,
        referentesGestion: this.listRefGestionSeleccionados,
        referentesTecnicos: this.listRefTecnicosSeleccionados,
        ruteadores: this.listRuteadoresSeleccionados,
        horarioOperacion: this.horarioOperacionFormControl.value,
        responsable: this.aeroplanta.responsable,
        sustituto: this.aeroplanta.sustituto,
        obtieneTelemediciones: this.obtieneTelemedicionesFormControl.value
      };

      if (this.authService.hasRole(TipoUsuario.JEFEDEAEROPLANTA)) {
        aeroplanta.responsable = this.responsableFormControl.value;
        aeroplanta.sustituto = this.suplenteFormControl.value;
      }
      try {
        const res = await this.cierreTurnoService.putAeroplantas(aeroplanta);
        if (res) {
          this.messageService.showSuccessMessage(`La aeroplanta fue editada correctamente.`);
          this.guardando = false;
        }
      } catch (err) {
        this.messageService.showErrorMessage(err.message);
        this.guardando = false;
      }
    }
  }

  abmContacto(contacto: Contacto, tipo: TipoResponsable) {
    switch (tipo) {
  
      case TipoResponsable.firmaOperadora: {
        this.listOperadoresDisponibles = this.listOperadoresDisponibles.filter(o => o.id !== contacto.id);
        if (!this.listOperadoresSeleccionados.some(o => o.id === contacto.id)) {
          this.listOperadoresSeleccionados.push(contacto);
        }
        const siguienteOperador = this.listOperadoresDisponibles.length > 0 ? this.listOperadoresDisponibles[0] : null;
        this.firmaOperadorFormControl.setValue(siguienteOperador);
        break;
      }
  
      case TipoResponsable.referenteComercial: {
        this.listRefComercialDisponibles = this.listRefComercialDisponibles.filter(c => c.id !== contacto.id);
        if (!this.listRefComercialSeleccionados.some(c => c.id === contacto.id)) {
          this.listRefComercialSeleccionados.push(contacto);
        }
        const siguienteComercial = this.listRefComercialDisponibles.length > 0 ? this.listRefComercialDisponibles[0] : null;
        this.referenteComercialFormControl.setValue(siguienteComercial);
        break;
      }
  
      case TipoResponsable.referenteGestion: {
        this.listRefGestionDisponibles = this.listRefGestionDisponibles.filter(g => g.id !== contacto.id);
        if (!this.listRefGestionSeleccionados.some(g => g.id === contacto.id)) {
          this.listRefGestionSeleccionados.push(contacto);
        }
        const siguienteGestion = this.listRefGestionDisponibles.length > 0 ? this.listRefGestionDisponibles[0] : null;
        this.referenteGestionFormControl.setValue(siguienteGestion);
        break;
      }
  
      case TipoResponsable.referenteTecnico: {
        this.listRefTecnicosDisponibles = this.listRefTecnicosDisponibles.filter(t => t.id !== contacto.id);
        if (!this.listRefTecnicosSeleccionados.some(t => t.id === contacto.id)) {
          this.listRefTecnicosSeleccionados.push(contacto);
        }
        const siguienteTecnico = this.listRefTecnicosDisponibles.length > 0 ? this.listRefTecnicosDisponibles[0] : null;
        this.referenteTecnicoFormControl.setValue(siguienteTecnico);
        break;
      }
  
      case TipoResponsable.ruteador: {
        this.listRuteadoresDisponibles = this.listRuteadoresDisponibles.filter(r => r.id !== contacto.id);
        if (!this.listRuteadoresSeleccionados.some(r => r.id === contacto.id)) {
          this.listRuteadoresSeleccionados.push(contacto);
        }
        const siguienteRuteador = this.listRuteadoresDisponibles.length > 0 ? this.listRuteadoresDisponibles[0] : null;
        this.ruteadorFormControl.setValue(siguienteRuteador);
        break;
      }
  
      default:
        break;
    }
  }
  

  borrarContacto(contacto: Contacto, tipo: TipoResponsable) {
    switch (tipo) {
      case TipoResponsable.firmaOperadora:
        this.listOperadoresSeleccionados = this.listOperadoresSeleccionados.filter(o => o != contacto);
        this.listOperadoresDisponibles.push(contacto);
        break;
      case TipoResponsable.referenteComercial:
        this.listRefComercialSeleccionados = this.listRefComercialSeleccionados.filter(c => c != contacto);
        this.listRefComercialDisponibles.push(contacto);
        break;
      case TipoResponsable.referenteGestion:
        this.listRefGestionSeleccionados = this.listRefGestionSeleccionados.filter(g => g != contacto);
        this.listRefGestionDisponibles.push(contacto);
        break;
      case TipoResponsable.referenteTecnico:
        this.listRefTecnicosSeleccionados = this.listRefTecnicosSeleccionados.filter(t => t != contacto);
        this.listRefTecnicosDisponibles.push(contacto);
        break;
      case TipoResponsable.ruteador:
        this.listRuteadoresSeleccionados = this.listRuteadoresSeleccionados.filter(r => r != contacto);
        this.listRuteadoresDisponibles.push(contacto);
        break;
      default:
        break;
    }
  }

  get tipoAeroplantaFormControl () {
    return this.aeroplantaForm.controls.tipoAeroplantaFormControl;
  }

  get productoFormControl() {
    return this.aeroplantaForm.controls.productoFormControl;
  }
  
  get detalleProductosFormControlArray(): FormArray {
    return this.aeroplantaForm.controls.detalleProductosFormControlArray as FormArray;
  }

  get firmaOperadorFormControl() {
    return this.aeroplantaForm.controls.firmaOperadorFormControl;
  }
  
  get referenteTecnicoFormControl() {
    return this.aeroplantaForm.controls.referenteTecnicoFormControl;
  }
  
  get referenteGestionFormControl() {
    return this.aeroplantaForm.controls.referenteGestionFormControl;
  }
  
  get referenteComercialFormControl() {
    return this.aeroplantaForm.controls.referenteComercialFormControl;
  }

  get ruteadorFormControl() {
    return this.aeroplantaForm.controls.ruteadorFormControl;
  }

  get horarioOperacionFormControl() {
    return this.aeroplantaForm.controls.horarioOperacionFormControl;
  }

  get responsableFormControl() {
    return this.aeroplantaForm.controls.responsableFormControl;
  }
  
  get suplenteFormControl() {
    return this.aeroplantaForm.controls.suplenteFormControl;
  }

  get obtieneTelemedicionesFormControl() {
    return this.aeroplantaForm.controls.obtieneTelemedicionesFormControl;
  }
}
